var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtominFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "7.1px",
    height: "13px",
    viewBox: "252.45 249.5 7.1 13",
    enableBackground: "new 252.45 249.5 7.1 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M259.25,249.503l-1.686-0.003c-1.894,0-3.118,1.256-3.118,3.199v1.475h-1.695 c-0.146,0-0.265,0.119-0.265,0.265v2.137c0,0.146,0.119,0.265,0.265,0.265h1.695v5.393c0,0.146,0.119,0.265,0.265,0.265h2.212 c0.146,0,0.265-0.119,0.265-0.265v-5.393h1.982c0.146,0,0.265-0.119,0.265-0.265l0.001-2.137c0-0.07-0.028-0.138-0.078-0.187 c-0.05-0.05-0.117-0.078-0.188-0.078h-1.983v-1.25c0-0.601,0.143-0.906,0.926-0.906l1.136,0c0.146,0,0.265-0.119,0.265-0.265 v-1.985C259.514,249.622,259.396,249.503,259.25,249.503z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtominFacebook);
export default __webpack_public_path__ + "static/media/etomin-facebook.5e26b25ae4b1d8a8d770bc0d693a5d27.svg";
export { ForwardRef as ReactComponent };